import React from 'react';
import { Box, Typography, SvgIcon } from '@mui/material';
import { APP_NAME } from '../constants/app';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  color?: 'default' | 'white';
}

const HouseIcon: React.FC<{ fontSize?: string; color?: 'default' | 'white' }> = ({
  fontSize = 'inherit',
  color = 'default'
}) => {
  const colors = color === 'white' ? {
    background: '#fffdf8',
    accent: '#f4e5d5',
    door: '#f4e5d5',
    stroke: '#fff7ef'
  } : {
    background: '#fff8f1',
    accent: '#c86b4a',
    door: '#c86b4a',
    stroke: '#234436'
  };

  return (
    <SvgIcon sx={{ fontSize }} viewBox="0 0 128 128">
      <rect width="128" height="128" rx="32" fill={colors.background} />
      <path
        d="M32 58L64 31L96 58"
        fill="none"
        stroke={colors.stroke}
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 56V89C42 92.866 45.134 96 49 96H79C82.866 96 86 92.866 86 89V56"
        fill="none"
        stroke={colors.stroke}
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M54 96V73C54 66.925 58.925 62 65 62C71.075 62 76 66.925 76 73V96"
        fill={colors.door}
      />
      <path
        d="M54 96V73C54 66.925 58.925 62 65 62C71.075 62 76 66.925 76 73V96"
        fill="none"
        stroke={colors.stroke}
        strokeWidth="8"
        strokeLinejoin="round"
      />
      <circle cx="92" cy="38" r="8" fill={colors.accent} />
    </SvgIcon>
  );
};

export const Logo: React.FC<LogoProps> = ({ size = 'medium', showText = true, color = 'default' }) => {
  const dimensions = {
    small: { iconSize: '32px', fontSize: '1.35rem' },
    medium: { iconSize: '40px', fontSize: '1.6rem' },
    large: { iconSize: '48px', fontSize: '2rem' },
  };

  const { iconSize, fontSize } = dimensions[size];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <HouseIcon fontSize={iconSize} color={color} />
      {showText && (
        <Typography
          variant="h6"
          sx={{
            fontSize,
            fontFamily: '"Fraunces", "Georgia", serif',
            fontWeight: 600,
            color: color === 'white' ? 'white' : 'primary.main',
            letterSpacing: '-0.03em',
          }}
        >
          {APP_NAME}
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
